import React from 'react';
import propTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { isAdmin } from '../../services/authenticationService';

const ProtectedRoute = ({ component, path }) => {
  const isLoggedIn = useSelector(state => state.auth.login.data);
  return isLoggedIn && isAdmin() ? <Route component={component} path={path} /> : <Redirect to="/" />;
};

ProtectedRoute.propTypes = {
  component: propTypes.object.isRequired,
  path: propTypes.string.isRequired,
};

export default ProtectedRoute;
